<template>
  <div class="p-6 bg-white/60 rounded-xl min-h-screen">
    <div class="flex justify-between items-center mb-6">
      <h5 class="text-l font-bold text-gray-800 inline-block transition-all duration-500">
        <span
            class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse">
           پکینگ در انتظار تایید
        </span>
      </h5>
      <div class="flex gap-3 mr-3">
        <button
            @click="refreshPacking"
            class="p-2 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:bg-gray-50 transform hover:scale-105"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24"
               stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
        </button>
      </div>
    </div>
    <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-3 mb-6 shadow-sm border border-gray-100">
      <div class="flex flex-wrap items-center gap-2">
        <!-- Search -->
        <div class="relative w-32">
          <input
              v-model="filters.name__icontains"
              placeholder="نام"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="flex gap-1">
          <button
              @click="resetFilters"
              class="p-1.5 bg-gradient-to-r from-gray-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="حذف فیلترها"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>

          <button
              @click="applyFilters"
              class="p-1.5 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="اعمال فیلتر"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead class="bg-blue-900 text-white bg-opacity-70">
          <tr>
            <th class="text-center p-3 border">ردیف</th>
            <th class="text-center p-3 border">شناسه</th>
            <th class="text-center p-3 border">نام بسته</th>
            <th class="text-center p-3 border">تاریخ</th>
            <th class="text-center p-3 border">تعداد آیتم‌ها</th>
            <th class="text-center p-3 border">تاریخ ایجاد</th>
            <th class="text-center p-3 border">حذف</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="7" class="p-4 text-center">
              <div class="flex justify-center items-center gap-2">
                <svg class="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                در حال بارگذاری...
              </div>
            </td>
          </tr>
          <tr v-else-if="packages.length === 0">
            <td colspan="7" class="p-4 text-center text-gray-500">
               یافت نشد
            </td>
          </tr>

          <tr v-for="(packageItem, index) in packages" :key="packageItem.id"
              @click="goDetail(packageItem.id)"
              class="hover:bg-gray-800  hover:text-white transition cursor-pointer ">
            <td class="text-center p-3 border">{{ calculateRowIndex(index) }}</td>
            <td class="text-center p-3 border">{{ packageItem.id }}</td>
            <td class="text-center p-3 border">{{ packageItem.name || '---' }}</td>
            <td class="text-center p-3 border">{{ packageItem.date }}</td>
            <td class="text-center p-3 border">{{ packageItem.items_count }}</td>
            <td class="text-center p-3 border">{{ packageItem.created_at}}</td>
            <td class="text-center p-3 border">
              <button
                  class="inline-flex items-center justify-center p-1.5 rounded bg-red-600 hover:bg-red-800 transition"
                  @click.stop="openDeleteConfirm(packageItem)"
                  title="حذف بسته"
              >
                <v-icon class="cursor-pointer" color="white">fa-trash</v-icon>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="p-4 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
        <div class="text-sm text-gray-600">
          نمایش {{ (currentPage - 1) * itemsPerPage + 1 }} تا
          {{ Math.min(currentPage * itemsPerPage, totalPackages) }} از
          {{ totalPackages }} محصول
        </div>
        <div class="flex gap-1">
          <button
              @click="prevPage"
              :disabled="currentPage === 1"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              :class="{ 'opacity-50 cursor-not-allowed': currentPage === 1 }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>
          <button
              v-for="page in visiblePages"
              :key="page"
              @click="goToPage(page)"
              class="p-2 text-center border border-gray-200 rounded-full transition-colors duration-200"
              :class="{
              'bg-gradient-to-r from-blue-500/60 to-blue-600/50 text-white shadow-md': page === currentPage,
              'bg-white bg-opacity-50 hover:bg-gray-50': page !== currentPage,
              'cursor-default': page === '...'
            }"
              :disabled="page === '...'"
          >
            {{ page }}
          </button>
          <button
              @click="nextPage"
              :disabled="currentPage * itemsPerPage >= totalPackages"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              :class="{ 'opacity-50 cursor-not-allowed': currentPage * itemsPerPage >= totalPackages }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="showNotification"
           class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-[90%] max-w-xs text-gray-100 bg-gray-900 rounded-lg shadow-lg border border-gray-700">

        <div class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-400 bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"/>
          </svg>
        </div>

        <div class="mr-3 text-sm font-normal pr-2"> بسته و فایل مرتبط حذف شد</div>

        <button @click="showNotification = false"
                class="mr-auto text-gray-400 hover:text-white rounded-lg p-1.5 hover:bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </transition>
    <transition name="fade">
      <div
          v-if="confirmDelete.show"
          class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
          @click.self="cancelDelete"
      >
        <div class="w-full max-w-md bg-white rounded-xl shadow-lg p-5">
          <h3 class="text-base font-semibold mb-2 text-gray-800">حذف بسته</h3>
          <p class="text-sm text-gray-600 mb-4">
            مطمئن هستید می‌خواهید
            <span class="font-medium text-gray-800" v-if="confirmDelete.target">{{ confirmDelete.target.name || 'این بسته' }}</span>
            <span class="font-medium text-gray-800" v-else>این بسته </span>
            را حذف کنید؟ (فایل مرتبط هم حذف می‌شود)
          </p>

          <div class="flex items-center justify-end gap-2">
            <button
                class="px-3 py-1.5 rounded-lg border bg-white hover:bg-gray-50"
                @click="cancelDelete"
                :disabled="confirmDelete.loading"
            >
              انصراف
            </button>
            <button
                class="px-3 py-1.5 rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-60"
                @click="performDelete"
                :disabled="confirmDelete.loading"
            >
              <span v-if="!confirmDelete.loading">حذف</span>
              <span v-else class="inline-flex items-center gap-2">
            <svg class="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
            </svg>
            در حال حذف...
          </span>
            </button>
          </div>
        </div>
      </div>
    </transition>


  </div>
</template>

<script>
export default {
  name: 'ExtractedEntrancePackageList',
  data() {
    return {
      showNotification: false,
      showQuickEdit: false,
      selectedProduct: null,
      selectedProductId: null,
      confirmDelete: { show: false, target: null, loading: false },
      loading: true,
      packages: [],
      totalPackages: 0,
      currentPage: 1,
      activePricing: [],
      itemsPerPage: 10,
      filters: {
        name__icontains: '',
      },
      categories: [],
      brands: [],
      currencies: [],
      productSelected: null,
      showProductStoreHandle: false
    }
  },
  computed: {
    visiblePages() {
      const totalPages = Math.ceil(this.totalPackages / this.itemsPerPage) || 1
      const range = 1
      const pages = []

      pages.push(1)

      if (this.currentPage - range > 2) pages.push('...')

      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i)
      }

      if (this.currentPage + range < totalPages - 1) pages.push('...')

      if (totalPages > 1) pages.push(totalPages)

      return pages
    },
  },
  methods: {
    openDeleteConfirm(packageItem) {
      this.confirmDelete.target = packageItem
      this.confirmDelete.show = true
    },
    cancelDelete() {
      this.confirmDelete.show = false
      this.confirmDelete.target = null
      this.confirmDelete.loading = false
    },
    async performDelete() {
      if (!this.confirmDelete.target?.id) return
      this.confirmDelete.loading = true
      try {
        await this.requestAsync?.({
          url: this.endpoint(`file_handler/deleteExtractedEntrancePackage/${this.confirmDelete.target.id}`),
          method: 'delete',
        })
        || await new Promise((resolve, reject) => {
          this.request({
            url: this.endpoint(`file_handler/deleteExtractedEntrancePackage/${this.confirmDelete.target.id}`),
            method: 'delete',
            success: resolve,
            error: reject,
          })
        })

        this.showNotificationMessage('بسته و فایل مرتبط حذف شد', 'success')
        this.cancelDelete()
        const isLastItemOnPage = this.packages.length === 1 && this.currentPage > 1
        if (isLastItemOnPage) this.currentPage -= 1
        this.fetchPacking()
      } catch (e) {
        this.confirmDelete.loading = false
        this.showNotificationMessage('خطا در حذف. دوباره تلاش کنید', 'error')
      }
    },
    calculateRowIndex(index) {
      return (this.currentPage - 1) * this.itemsPerPage + index + 1;
    },
    viewDetails(packageItem) {
      alert(`جزئیات بسته: ${packageItem.name}\nشناسه: ${packageItem.id}\nتعداد آیتم‌ها: ${packageItem.items_count}`);
    },
    downloadFile(packageItem) {
      if (!packageItem.uploaded_file) {
        this.showNotificationMessage('فایل آپلود شده موجود نیست', 'error');
        return;
      }

      this.showNotificationMessage('در حال دانلود فایل...', 'success');
      // شبیه‌سازی دانلود فایل
      setTimeout(() => {
        this.showNotificationMessage('فایل با موفقیت دانلود شد', 'success');
      }, 1500);
    },
    exportToExcel() {
      this.showNotificationMessage('در حال آماده‌سازی خروجی Excel...', 'success');
      // شبیه‌سازی تولید فایل Excel
      setTimeout(() => {
        this.showNotificationMessage('خروجی Excel با موفقیت تولید شد', 'success');
      }, 2000);
    },

  isActive(product) {
      return this.activePricing.some(p => p === product);
    },
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },
    fetchBrands() {
      this.request({
        url: this.endpoint('api/brands'),
        method: 'get',
        success: (data) => {
          this.brands = data
        }
      })
    },
    handleDone(product){
      this.request({
        url: this.endpoint('store_handle/productStoreInventoryHandleCreate'),
        method: 'post',
        data: product,
        success: (data) => {
          this.showNotificationMessage()
          this.fetchPacking()
        },
      })
    },
    fetchPacking() {
      this.loading = true

      const params = {
        limit: this.itemsPerPage,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        ...this.filters
      }

      Object.keys(params).forEach(key => {
        if (params[key] === '') {
          delete params[key]
        }
      })

      this.request({
        url: this.endpoint('file_handler/extractedEntrancePackage/all'),
        method: 'get',
        params,
        success: (data) => {
          this.packages = data.results
          this.totalPackages = data.count
          console.log(this.packages)
          this.loading = false
        },
        error: () => {
          this.loading = false
        }
      })
    },

    applyFilters() {
      this.currentPage = 1
      this.fetchPacking()
    },

    resetFilters() {
      this.filters = {
        id_in: '',
        name__icontains: '',
      }
      this.applyFilters()
    },

    refreshPacking() {
      this.fetchPacking()
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchPacking()
      }
    },

    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalPackages) {
        this.currentPage++
        this.fetchPacking()
      }
    },
    goDetail(id) {
      this.$router.push(`/panel/entrancePackageItemDetail/${id}`)
    },

    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
        this.fetchPacking()
      }
    },
    productStoreHandle(product) {
      this.selectedProduct = product
      this.showProductStoreHandle = true

    },

    active(product) {
      const index = this.activePricing.indexOf(product);
      if (index > -1) {
        this.activePricing.splice(index, 1);
      } else {
        this.activePricing.push(product);
      }
    },
    calculate_discount(price, discount) {
      return price -  (price / 100 * discount)
    },
    closeProductStoreHandle() {
      this.selectedProduct = null
      this.showProductStoreHandle = false
    },


  },
  mounted() {
    this.fetchBrands()
    this.fetchPacking()
  }
}
</script>

<style>
/* RTL support */
body {
  direction: rtl;
  text-align: right;
}

/* Glass morphism effect */
.glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

/* Neumorphism effect */
.neumorphism {
  border-radius: 16px;
  background: #f0f0f0;
  box-shadow: 8px 8px 16px #d9d9d9,
  -8px -8px 16px #ffffff;
}

/* Smooth transitions */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.glass-card {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.bg-secondary {
  background-color: #424242;
}


</style>